export default __webpack_public_path__ + "static/media/18-LundSolfilm.24f35c0a.png";